// src/utils/layout/rescueTesisatFromMainFrame.js
//
// Layout cleanup oncesi tesisat meshlerini mainFrame'den scene root'a kurtarir.

import * as THREE from 'three';
import { isTesisatMesh } from '../../../modules/fpSync';
import { flog } from '../../../utils/forensics';

export function rescueTesisatFromMainFrame(scene, mainFrame) {
  if (!scene || !mainFrame) return;
  const tesisatToRescue = [];
  mainFrame.traverse((obj) => {
    if (!isTesisatMesh(obj)) return;
    // Tesisat PARÇASINI (atası tesisat olan child — örn. cableShaft group'unun
    // fillMesh/border/diagonal child'ları group.userData'yı miras alıp type='cableShaft'
    // taşır) AYRI kurtarma; üst tesisat'la birlikte gelir. Aksi halde group'tan
    // koparılıp yanlış (group-local) konuma yerleşiyor → cableShaft kat planından kopuyor.
    let p = obj.parent, isPart = false;
    while (p && p !== scene) { if (isTesisatMesh(p)) { isPart = true; break; } p = p.parent; }
    if (isPart) return;
    tesisatToRescue.push(obj);
  });
  flog('FAZ10_RESCUE_ONCESI', {
    tesisatCount: tesisatToRescue.length,
    items: tesisatToRescue.map(t => ({
      id: t.userData?.id,
      type: t.userData?.type || t.userData?.kind,
      worldPos: t.getWorldPosition(new THREE.Vector3()).toArray(),
      parent: t.parent?.name || t.parent?.uuid?.slice(0, 8),
    })),
  });
  for (const t of tesisatToRescue) {
    // Editor tip / tam rebuild senaryosunda yeni fpMesh farklı bir position'da
    // yaratılıyor. Sweep `fpMesh.attach()` ile dünya pos'unu koruyunca tesisat
    // eski world'de kalıp yeni kat planından AYRIluyordu. Bunu engellemek için:
    // rescue'dan önce tesisat'ın eski fpMesh-child LOCAL pos'unu sakla;
    // sweepTesisatToFloorPlanMeshes (floorPlanMesh.js:301-308) `_savedLocalPos`
    // varsa fpMesh.add + position.set(local) yolunu kullanır → tesisat yeni
    // fpMesh içinde aynı LOCAL konuma oturur, kat planıyla birlikte hareket eder.
    t.userData._savedLocalPos = {
      x: t.position.x,
      y: t.position.y,
      z: t.position.z,
    };
    scene.attach(t);
  }
  flog('FAZ10_RESCUE_SONRASI', {
    rescuedCount: tesisatToRescue.length,
    items: tesisatToRescue.map(t => ({
      id: t.userData?.id,
      newParent: t.parent?.name || t.parent?.uuid?.slice(0, 8),
      localPos: t.position.toArray(),
    })),
  });
}

export function disposeMainFrame(scene, mainFrame) {
  if (!mainFrame) return;
  mainFrame.traverse((child) => {
    // Bekleyen async OLE decode callback'leri bu bayrağı görüp yeni texture
    // bağlamadan çıkar (dxfDrawCore applyOleTexture guard'ı) — parent detach
    // edilse bile orphan texture oluşmaz.
    child.userData = child.userData || {};
    child.userData.disposed = true;
    if (child.geometry) child.geometry.dispose();
    if (child.material) {
      const mats = Array.isArray(child.material) ? child.material : [child.material];
      mats.forEach(m => { if (m.map) m.map.dispose(); m.dispose(); });
    }
  });
  scene.remove(mainFrame);
}
